
import { Progress } from "@/components/ui/progress";
import { ProcessingStage, ProcessingStages } from "./ProcessingStages";

interface UploadProgressProps {
  stage: ProcessingStage;
  progress: number;
  isUploading: boolean;
  isError?: boolean;
  errorMessage?: string;
}

export const UploadProgress = ({ 
  stage, 
  progress, 
  isUploading,
  isError = false,
  errorMessage
}: UploadProgressProps) => {
  if (!isUploading) return null;

  return (
    <ProcessingStages 
      currentStage={stage}
      progress={progress}
      isError={isError}
      errorMessage={errorMessage}
    />
  );
};
